import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { injectIntl } from 'react-intl';

class Question extends Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.handleChange(event.target.value);
  }

  render() {
    return (
      <Form.Group controlId="question">
        <Form.Label>{this.props.label}</Form.Label>
        <Form.Control
          as="textarea"
          onChange={this.handleChange}
          // Inline properties need to be Stings
          // In order to keep translation managment
          // working we use FormattedMessage obj anyway
          placeholder={this.props.intl.formatMessage(
            this.props.placeholder.props
          )}
          rows="6"
        />
      </Form.Group>
    );
  }
}

Question.propTypes = {
  label: PropTypes.any,
  placeholder: PropTypes.any,
  handleChange: PropTypes.func.isRequired
};

export default injectIntl(Question);
